<template>
  <div class="content-wrapper recap-wrapper">
    <div class="content-body">

      <!-- HEADER -->
      <div class="recap-actions">
        <router-link
          :to="{ name: 'chantier-detail', params: { id: $route.params.id } }"
          class="chantier-back"
        >
          <feather-icon
            icon="ArrowLeftIcon"
            size="14"
            class="mr-50"
          />
          Retour au chantier
        </router-link>
      </div>

      <!-- DEFERRED-FEATURE PLACEHOLDER -->
      <!--
        Le récapitulatif / export PDF est une fonctionnalité reportée (post-MVP).
        Cette vue est volontairement neutralisée : aucun appel backend, aucune
        donnée de maquette, aucun v-html. Voir le plan front Chantiers (Task 10).
      -->
      <div class="recap-soon">
        <feather-icon
          icon="FileTextIcon"
          size="40"
          class="recap-soon__icon"
        />
        <h2 class="recap-soon__title">
          Fonctionnalité bientôt disponible
        </h2>
        <p class="recap-soon__text">
          Le récapitulatif imprimable des chantiers est en cours de préparation
          et sera proposé dans une prochaine version.
        </p>
        <b-button
          variant="primary"
          size="sm"
          :to="{ name: 'chantier-detail', params: { id: $route.params.id } }"
        >
          <feather-icon
            icon="ArrowLeftIcon"
            size="14"
            class="mr-50"
          />
          Retour au chantier
        </b-button>
      </div>

    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'ChantierRecapView',
  components: {
    BButton,
  },
}
</script>

<style scoped lang="scss">
$at-green:   #1c4d4d;
$at-orange:  #ff6131;
$at-ink-500: #5A7373;
$at-ink-100: #E4ECEC;

.recap-wrapper { min-height: 100vh; }

.recap-actions {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

.chantier-back {
  display: inline-flex;
  align-items: center;
  color: $at-ink-500;
  font-size: 13px;
  text-decoration: none;
  &:hover { color: $at-orange; }
}

.recap-soon {
  text-align: center;
  max-width: 560px;
  margin: 48px auto;
  padding: 48px 32px;
  background: #fff;
  border: 1px dashed $at-ink-100;
  border-radius: 12px;

  &__icon { color: $at-green; margin-bottom: 12px; }
  &__title {
    font-size: 20px;
    color: $at-green;
    font-weight: 600;
    margin: 0 0 10px;
  }
  &__text {
    color: $at-ink-500;
    font-size: 14px;
    margin: 0 0 20px;
  }
}
</style>
